import gql from 'graphql-tag';
import { sanityDocumentFieldsFragment, supplyObjectFieldsFragment } from '@graphql/admin/fragments';

export const updateSupplyObjectMutation = gql`
  mutation UpdateSupplyObject($id: ID!, $input: UpdateSupplyObjectInput!) {
    updateSupplyObject(id: $id, input: $input) {
      ...AdminSanityDocumentFields
      ...AdminSupplyObjectFields
    }
  }

  ${sanityDocumentFieldsFragment}
  ${supplyObjectFieldsFragment}
`;